export default "__VITE_ASSET__CJEpldhr__"